import { formValidator } from "./WtoFormValidator";
import { Plover } from "@blisspointmedia/bpm-types/dist/webTrafficOptimization";
import * as R from "ramda";
import { defaultCustomRetention, defaultTimeframe } from "./WtoFormContext";
import { convert24hrTo12hr } from "../utils/time-utils";

export const VALID_URL_REGEXP = /^https:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#()?&//=]*)/;

export const DAYS = [
  {
    key: "Sunday",
    label: "S",
    number: 0,
  },
  {
    key: "Monday",
    label: "M",
    number: 1,
  },
  {
    key: "Tuesday",
    label: "T",
    number: 2,
  },
  {
    key: "Wednesday",
    label: "W",
    number: 3,
  },
  {
    key: "Thursday",
    label: "T",
    number: 4,
  },
  {
    key: "Friday",
    label: "F",
    number: 5,
  },
  {
    key: "Saturday",
    label: "S",
    number: 6,
  },
];

export const CSV_FILE_BASE64 =
  "KlBsZWFzZSBlbnRlciB0aGUgdmFsaWQgaW5wdXQgb25seSBhbHBoYW51bWVyaWMgdmFsdWVzIGFyZSBhbGxvd2VkLiwiKlRoZSBkb21haW4gc2hvdWxkIG1hdGNoIHBhcnRuZXItc3BlY2lmaWMgbGlzdGVkIGRvbWFpbnMuIEV4YW1wbGUgOi1hbXBzdGFnaW5nLmFtcHVzaC51cyx3d3cuYW1wdXNoLnVzLHMuaW5zaWRlcmVudnkuY29tLiIsKkZvbGRlciBwYXRoIG11c3QgYmUgc3RhcnQgd2l0aCAnLycgYW5kIGVuZHMgd2l0aCAnLycuLCpQbGVhc2UgZW50ZXIgdGhlIHZhbGlkIGlucHV0IHdpdGhvdXQgYWRkaW5nIHNwYWNlIGFuZCBvbmx5IGFscGhhbnVtZXJpYyBhbmQgJy0nIHZhbHVlcyBhcmUgYWxsb3dlZC4sKlBsZWFzZSBlbnRlciB0aGUgdmFsaWQgaW5wdXQgd2l0aG91dCBhZGRpbmcgc3BhY2UgYW5kIG9ubHkgYWxwaGFiYXRlcyB2YWx1ZXMgYXJlIGFsbG93ZWQuLCpQbGVhc2UgZW50ZXIgdGhlIHZhbGlkIGlucHV0IHdpdGhvdXQgYWRkaW5nIHNwYWNlIGFuZCBvbmx5IGFscGhhYmF0ZXMgdmFsdWVzIGFyZSBhbGxvd2VkLiwqUGxlYXNlIGlucHV0IG51bWVyaWMgdmFsdWVzIG9ubHkuLCpPbmx5IEFscGhhbnVtZXJpYyB2YWx1ZXMgYXJlIGFsbG93ZWQuLCIqT25seSBsZXR0ZXJzLCBkaWdpdHMsIGFuZCBkYXNoICgtKSBjaGFyYWN0ZXJzIGFyZSBhY2NlcHRlZC4iLCpQbGVhc2UgaW5wdXQgbnVtZXJpYyB2YWx1ZXMgb25seS4sKlBsZWFzZSBlbnRlciB0aGUgdmFsaWQgaW5wdXQgd2l0aCBhbHBoYW51bWVyaWMgdmFsdWVzLCpWYWxpZCBVUkwgbXVzdCBzdGFydCB3aXRoIEhUVFBTIGFuZCBjb250YWluIGZ1bGwgVVJMIHdpdGhvdXQgVVRNIFBhcmFtZXRlcnMuCnJvdXRlX25hbWUsZG9tYWluLGZvbGRlcl9wYXRoLHBsb3Zlcl91cmwsdXRtX2V4cCxleHBfbmFtZSx2ZXJzaW9uL2V4cGVyaW1lbnQgbnVtYmVyLGRlZmF1bHRfaWQsZGVmYXVsdF91cmwsSG93IE1hbnkgVmFyaWFudHMgaW4gdGhpcyByb3V0ZT8sVmFyaWFudCBOYW1lIChQbGVhc2UgaW5wdXQgZWFjaCB2YWx1ZSBvbiBhIHNlcGFyYXRlIGxpbmUpLFZhcmlhbnQgVVJML0Rlc3RpbmF0aW9uIFVSTChQbGVhc2UgaW5wdXQgZWFjaCB2YWx1ZSBvbiBhIHNlcGFyYXRlIGxpbmUpCg==";

export const EXCEL_FILE_BASE64 =
  "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";

export const getParamFunnelStep = (utmParam: string): string =>
  utmParam.length > 0 ? utmParam.split("utm_")[1].split("_")[0] : "";

export const getParamTestName = (utmParam: string): string =>
  utmParam.length > 0 ? utmParam.split("=")[1].split(/[0-9]/)[0] : "";

export const getParamVersionNumber = (utmParam: string): string => {
  let match = utmParam.match(/^[^0-9]+/);
  if (match) {
    let versionNumber = utmParam.length > 0 ? utmParam.split(match[0])[1] : "";
    return versionNumber;
  }
  return "";
};

export const updateParamFunnelStep = (funnelStep: string, testId: string): string =>
  `utm_${funnelStep.toLocaleLowerCase()}_exp=${getParamTestName(testId)}${getParamVersionNumber(
    testId
  )}`;

export const updateParamTestName = (testName: string, testId: string): string =>
  `utm_${getParamFunnelStep(testId)}_exp=${testName}${getParamVersionNumber(testId)}`;

export const updateParamVersionNumber = (versionNumber: number, testId: string): string =>
  `utm_${getParamFunnelStep(testId)}_exp=${getParamTestName(testId)}${
    versionNumber < 1 ? 1 : versionNumber
  }`;

export const formatDefaultId = (id: string): string =>
  id ? `${id?.toString()?.indexOf("f-") === -1 ? "f-" : ""}${id}` : "";

export const prepPayloadToCreateTest = (
  configObj: Record<string, any>,
  ploverObj: Record<string, any>,
  currentPartnerId: string,
  userEmail: string
): void => {
  ploverObj.created_by = userEmail || "";
  ploverObj.test_name = configObj.test_name ? configObj.test_name : "";
  ploverObj.utm_test_id = configObj.utm_test_id ? configObj.utm_test_id : "";
  ploverObj.variants = configObj.variants ? configObj.variants : "";
  ploverObj.default_id = formatDefaultId(configObj.default_id);
  ploverObj.default_url = configObj.default_url ? configObj.default_url : "";
  ploverObj.plover_url = configObj.plover_url ? configObj.plover_url : "";
  ploverObj.folder_path = configObj.folder_path?.toString()?.replace(/^\/|\/$/g, "");
  ploverObj.notes = configObj.notes ? configObj.notes : "";
  ploverObj.domain = configObj.domain ? configObj.domain : "";
  ploverObj.rules = [];
  ploverObj.status = "draft";
  ploverObj.company = currentPartnerId || "";
  ploverObj.updated_by = userEmail || "";
};

let isNum = /^\d+$/;

export const formatPloverObj = (
  ploverArray: Record<string, any>[],
  partnerDomainArray: Record<string, any>[],
  currentPartnerId: string,
  userEmail: string
): { bulkPloverPayload: any; frontEndValidationsArray: any } => {
  let bulkPloverPayload: any = [];
  let frontEndValidationsArray: any = [];
  let invalidMsg: any = "";

  let filteredArray: any = [];
  partnerDomainArray.forEach(element => {
    filteredArray.push(element.web_url);
  });

  try {
    for (let i = 0; i < ploverArray.length; i++) {
      let eachData = ploverArray[i];
      if (eachData.route_name?.length > 0) {
        eachData.test_name = eachData.route_name;
        delete eachData.route_name;
      }

      let ploverObj = {};
      if (!eachData.utm_test_id) {
        if (eachData.utm_exp && eachData.exp_name && eachData["version/experiment number"]) {
          eachData.utm_test_id = `utm_${eachData.utm_exp
            .toString()
            .trim()}_exp=${eachData.exp_name.toString().trim()}${eachData[
            "version/experiment number"
          ]
            .toString()
            .trim()}`;
        } else {
          eachData.utm_test_id = "";
        }
      }

      if (!eachData.variants) {
        let variantsName = eachData["Variant Name (Please input each value on a separate line)"]
          ?.toString()
          ?.split("\n")
          ?.map((eachData: any) => eachData.trim());
        let variantsURL = eachData[
          "Variant URL/Destination URL(Please input each value on a separate line)"
        ]
          ?.toString()
          ?.split("\n")
          ?.map((eachData: any) => eachData.trim());
        if (variantsName && variantsURL && variantsName.length === variantsURL.length) {
          invalidMsg = "";
          let object = variantsName?.map((element: any, idx: any) => {
            return {
              variant_id: element ? element : "",
              variant_url: variantsURL?.length > 0 ? variantsURL[idx] : "",
            };
          }, {});
          eachData.variants = object;
        } else {
          if (!variantsName && !variantsURL) {
            invalidMsg = `Sheet Row ${
              i + 2
            } - The variant names and variant URLs cannot be left empty.`;
          } else {
            invalidMsg = `Sheet Row ${
              i + 2
            } - The number of variant names and variant URLs is not aligned.`;
          }
          eachData.variants = [];
        }
      }
      if (!eachData.plover_url) {
        eachData.plover_url = "";
      } else if (eachData.plover_url) {
        eachData.plover_url = eachData.plover_url.toString().trim();
      }
      if (!eachData.test_name) {
        eachData.test_name = "";
      } else if (eachData.test_name) {
        eachData.test_name = eachData.test_name.toString().trim();
      }
      if (!eachData.default_id) {
        eachData.default_id = "";
      } else if (eachData.default_id) {
        eachData.default_id = eachData.default_id.toString().trim();
      }
      if (!eachData.default_url) {
        eachData.default_url = "";
      } else if (eachData.default_url) {
        eachData.default_url = eachData.default_url.toString().trim();
      }
      if (!eachData.folder_path) {
        eachData.folder_path = "/";
      } else if (eachData.folder_path) {
        eachData.folder_path = eachData.folder_path.toString().trim();
      }
      if (!eachData.domain) {
        eachData.domain = "";
      } else if (eachData.domain) {
        eachData.domain = eachData.domain.toString().trim();
      }

      prepPayloadToCreateTest(eachData, ploverObj, currentPartnerId, userEmail);
      bulkPloverPayload.push(ploverObj);

      let validationFieldsArray = [
        "test_name",
        "utm_test_id",
        "variants",
        "default_id",
        "default_url",
        "plover_url",
        "folder_path",
        "domain",
      ];
      let bulkPLover = {
        isBulkPlover: true,
        currentRow: i + 2,
        partnerDomainArray: filteredArray,
      };

      frontEndValidationsArray = formValidator(eachData, validationFieldsArray, bulkPLover);
      if (
        eachData["version/experiment number"] &&
        !isNum.test(eachData["version/experiment number"])
      ) {
        frontEndValidationsArray.push(
          `Sheet Row ${i + 2}- version/experiment should be number only`
        );
      }
      if (invalidMsg) {
        frontEndValidationsArray.push(invalidMsg);
      }
      if (frontEndValidationsArray.length > 0) {
        break;
      }
    }

    if (frontEndValidationsArray.length > 0) {
      bulkPloverPayload = [];
      return { bulkPloverPayload, frontEndValidationsArray };
    } else {
      return { bulkPloverPayload, frontEndValidationsArray };
    }
  } catch (error) {
    bulkPloverPayload = [];
    frontEndValidationsArray = ["Something went wrong while formatting the data."];
    return { bulkPloverPayload, frontEndValidationsArray };
  }
};

export const isSavedDraft = (data: Plover): boolean =>
  !R.isNil(data.id) && !R.isEmpty(data.id) && data.status.toLocaleLowerCase() === "draft";

export const buildPloverUrl = (domain: string, folderPath: string, ploverUrl: string): string => {
  let url = `https://${domain || ""}${domain ? (folderPath ? `${folderPath}` : "/") : ""}${
    domain ? ploverUrl || "" : ""
  }`;
  return url;
};

export const trimBackslashes = (path: string): string => {
  if (path.length >= 1 && path.charAt(0) === "/") {
    path = path.substring(1, path.length);
  }
  if (path.length >= 1 && path.charAt(path.length - 1) === "/") {
    path = path.substring(0, path.length - 1);
  }
  return path;
};

export const joinBackslashes = (path: string): string => {
  if (path === "") {
    return "/";
  }
  if (path.length > 0 && path.charAt(0) !== "/") {
    path = `/${path}`;
  }
  if (path.length > 1 && path.charAt(path.length - 1) !== "/") {
    path = `${path}/`;
  }
  return path;
};

export const formatRules = (
  rules: Record<string, any>[],
  removeTimeframeTrackingParam?: boolean
): Record<string, any>[] => {
  const formattedRules = R.clone(rules);
  rules.forEach((rule: Record<string, any>, ruleIndex) => {
    const formattedRule = R.clone(rule);
    if (rule.conditions) {
      rule.conditions.forEach(
        (
          condition: { operator: string; trigger: string; rule: string; value: string },
          conditionIndex
        ) => {
          const formattedCondition: string[] = [];
          formattedCondition.push(condition.trigger);
          formattedCondition.push(condition.rule);
          formattedCondition.push(condition.value);
          formattedCondition.push(condition.operator);
          formattedRule.conditions[conditionIndex] = R.clone(formattedCondition);
        }
      );
    }
    if (removeTimeframeTrackingParam && rule.timeframe && rule.timeframe_enabled) {
      const formattedTimeframe = R.clone(rule.timeframe);
      formattedTimeframe.timeframe_utm_test_id_enabled = false;
      formattedTimeframe.utm_test_id = "";
      formattedRule.timeframe = formattedTimeframe;
    }
    if (rule.customRetention && rule.customRetention.customRetentionStatus) {
      const formattedRetention = R.clone(rule.customRetention);
      formattedRetention.startTime = R.clone(rule.customRetention.startDate);
      formattedRetention.formattedStartTime = R.clone(rule.customRetention.formattedStartDate);
      formattedRule.customRetention = formattedRetention;
    }
    formattedRules[ruleIndex] = formattedRule;
  });
  return formattedRules;
};

export const parseTimestampComponents = (
  data: Record<string, any>,
  prop: string,
  defaultDate: string
): {
  year: any;
  month: any;
  day: any;
  hour24: any;
  hour12: string;
  period: string;
  minute: any;
  offset: string;
  timezone: any;
} => {
  const [defaultYear, defaultMonth, defaultDay] = defaultDate.split("-").map(token => token);
  const { time_zone } = data;

  return {
    year: R.isEmpty(data[prop]) ? defaultYear : data[prop].substring(0, 4),
    month: R.isEmpty(data[prop]) ? defaultMonth : data[prop].substring(5, 7),
    day: R.isEmpty(data[prop]) ? defaultDay : data[prop].substring(8, 10),
    hour24: R.isEmpty(data[prop]) ? "00" : data[prop].substring(11, 13),
    hour12: R.isEmpty(data[prop])
      ? "12"
      : convert24hrTo12hr(data[prop].substring(11, 16)).split(":")[0],
    period: R.isEmpty(data[prop]) ? "am" : Number(data[prop].substring(11, 13)) > 11 ? "pm" : "am",
    minute: R.isEmpty(data[prop]) ? "00" : data[prop].substring(14, 16),
    offset: R.isEmpty(data[prop])
      ? "+00:00"
      : `${data[prop].substring(19, 20)}${data[prop].substring(20, 25)}`,
    timezone: R.isEmpty(time_zone) ? "UTC" : time_zone,
  };
};

export const capitalize = (str: string): string => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

export const parseTimestampTimeframe = (
  defaultDate: string,
  data?: Record<string, any>
): {
  start: {
    year: any;
    month: any;
    day: any;
    hour24: any;
    hour12: string;
    period: string;
    minute: any;
    offset: string;
    timezone: any;
  };
  end: {
    year: any;
    month: any;
    day: any;
    hour24: any;
    hour12: string;
    period: string;
    minute: any;
    offset: string;
    timezone: any;
  };
} => {
  let timeframe = data || defaultTimeframe;

  return {
    start: parseTimestampComponents(timeframe, "startDateTime", defaultDate),
    end: parseTimestampComponents(timeframe, "endDateTime", defaultDate),
  };
};

export const parseTimestampDowOperations = (
  defaultDate: string,
  data: Record<string, any>[]
): {
  start: {
    year: any;
    month: any;
    day: any;
    hour24: any;
    hour12: string;
    period: string;
    minute: any;
    offset: string;
    timezone: any;
  };
  end: {
    year: any;
    month: any;
    day: any;
    hour24: any;
    hour12: string;
    period: string;
    minute: any;
    offset: string;
    timezone: any;
  };
}[] =>
  data.map(operation => ({
    start: parseTimestampComponents(operation, "start_time", defaultDate),
    end: parseTimestampComponents(operation, "end_time", defaultDate),
  }));

export const parseTimestampCustomRetention = (
  defaultDate: string,
  data: Record<string, any>
): {
  year: any;
  month: any;
  day: any;
  hour24: any;
  hour12: string;
  period: string;
  minute: any;
  offset: string;
  timezone: any;
} => {
  let retention = R.isEmpty(data) ? defaultCustomRetention : data;
  return parseTimestampComponents(retention, "startDate", defaultDate);
};

export const setTimestampTime = (values: {
  year: any;
  month: any;
  day: any;
  hour24: any;
  hour12: string;
  period: string;
  minute: any;
  offset: string;
  timezone: any;
}): string =>
  `${values.year}-${values.month}-${values.day}T${values.hour24}:${values.minute}:00${values.offset}`;

export const setFormattedTime = (values: {
  year: any;
  month: any;
  day: any;
  hour24: any;
  hour12: string;
  period: string;
  minute: any;
  offset: string;
  timezone: any;
}): string =>
  `${values.year}/${Number(values.month)}/${Number(values.day)}, ${values.hour12}:${values.minute}${
    values.period
  }`;

export const formatTimestampOffset = (offset: number): string =>
  `${offset < 0 ? "-" : "+"}${Math.abs(Math.floor(offset)).toString().padStart(2, "0")}:00`;
